// 放置你要重置的数据
const initState = {
  tableData: null, // 表格数据
  groupOptions: [],
  bid_mode: null, // 出价方式选项
  begin_date: new Date(), // 排期出价，投放日期
  time_set: '111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
  cost_type: 4, // 未知
  cost_price: null, // 出价
  optimization_goal: null, // 优化目标
  adgroup_name: null, // 广告名称
  bid_strategy: null, // 出价策略
  day_budget: null, // 广告日预算
  offer_type: null, // 出价类型
  budget_select: null // 广告日预算选项
}

// state
const state = {
  // 参数解构
  ...initState,
  initState() {
    return initState
  }
}

const mutations = {
  // 存放表格数据
  offerTableData: (state, data) => {
    state.tableData = data
  },
  // 设为新组别
  newGroup(state, data) {
    if (state.tableData[data.index].length === 1) {
      return
    }
    state.tableData.push([state.tableData[data.index][data.inx]])
    state.tableData[data.index].splice(data.inx, 1)
  },
  // 改变分组
  changeGroup(state, data) {
    state.tableData[data.e].push(state.tableData[data.index][data.inx]) // 更改分组
    if (state.tableData[data.index].length === 1) { // 判断分组只有一个元素 直接删除该分组
      state.tableData.splice(data.index, 1)
    } else {
      state.tableData[data.index].splice(data.inx, 1)
    }
  },
  // 获取bid_mode
  getBidMode(state, data) {
    state.bid_mode = data
    console.log(state.bid_mode, '我是bid_mode')
  },
  // 获取begin_date数据
  getBeginDateData(state, data) {
    state.begin_date = data
    console.log(state.begin_date, '我是state')
  },
  // 获取cost_type未知数据
  getCostType(state, data) {
    state.cost_type = data
    console.log(state.cost_type, '我是cost_type')
  },
  // 获取time_set数据
  getTimeSet(state, data) {
    state.time_set = data
    console.log(state.time_set, '我是time_set')
  },
  // 获取cost_price出价数据
  getCostPrice(state, data) {
    state.cost_price = data
    console.log(state.cost_price, '我是cost_price')
  },
  // 获取optimization_goal优化目标数据
  getOptimizationGoal(state, data) {
    state.optimization_goal = data
    console.log(state.optimization_goal, '我是optimization_goal')
  },
  // 获取adgroup_name广告名称数据
  getAdgroupName(state, data) {
    state.adgroup_name = data
    console.log(state.adgroup_name, '我是adgroup_name')
  },
  // 获取bid_strategy出价策略数据
  getBidStrategy(state, data) {
    state.bid_strategy = data
    console.log(state.bid_strategy, '我是bid_strategy')
  },
  getDayBudget(state, data) {
    state.day_budget = data
    console.log(state.day_budget, '我是day_budget')
  },
  // 获取出价类型选项
  getOfferType(state, data) {
    state.offer_type = data
    console.log(state.offer_type, '我是offer_type选项')
  },
  // 广告日预算选项
  getAdDayBudgetSelect(state, data) {
    state.budget_select = data
    console.log(state.budget_select, 'budget_select')
  }
}

export default {
  namespaced: true,
  state,
  mutations
}

